export enum EventType {
    'REFRESH.MENU.USER_DATA' = 'REFRESH.MENU.USER_DATA',
    'REFRESH.PERSONAL_DATA_PANE.PROFILE_DATA' = 'REFRESH.PERSONAL_DATA_PANE.PROFILE_DATA',
    'REPORT.DEFECTS.RELOAD' = 'REPORT.DEFECTS.RELOAD',
    'REPORT.LIST.RELOAD' = 'REPORT.LIST.RELOAD',
    'REPORT.LIST.LOCATION' = 'REPORT.LIST.LOCATION',
    'REPORT.NETWORK_STATUS_CHANGE' = 'REPORT.NETWORK_STATUS_CHANGE',
    'REFRESH.BACK_RIDE_FORM_FIELDS' = 'REFRESH.BACK_RIDE_FORM_FIELDS',
    'LOGIN.RESET_PIN' = 'LOGIN.RESET_PIN',
    'LOCATION.RELOAD_CHECK' = 'LOCATION.RELOAD_CHECK',
}